import Cookies from 'js-cookie';

/**
 *
 * @param {*} itemSpecInfo 購物車商品
 * @returns K 值/ null
 * @description 目前由後端判斷一律回傳 null /確定時看是否要再拿掉
 */
function detectUtmK(itemSpecInfo) {
  return null;
}

export function shareCode() {
  let USCValue = '';

  if (Cookies.get('U_SC')) {
    USCValue = Cookies.get('U_SC');
  }

  return USCValue ? USCValue : null;
}

export default detectUtmK;
